export default __webpack_public_path__ + "images/logoIndeedLabs.660676b084a1e97db6cc834e5280cce3.svg"